import { useState } from 'react'
import { getReceiptSsnValidationSchema } from '../components/CourseRegistrationStepFour'
import { useForm } from './useForm'
import { Currency } from '../../../pure-js/types/GrooverTypes'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useReceiptSsn = (saveFn: (ssn: string) => Promise<any>, currency?: Currency) => {
  const [showSsnInput, setShowSsnInput] = useState(false)
  const [savedSsn, setSavedSsn] = useState<string | undefined>(undefined)
  const [isSavingSsn, setIsSavingSsn] = useState(false)

  const ssnFormProps = useForm<{ userSsnField: string }>(getReceiptSsnValidationSchema(currency), {
    defaultValues: { userSsnField: '' },
    mode: 'all',
    reValidateMode: 'onChange'
  })

  const handleSaveSsn = (ssn: string) => {
    setIsSavingSsn(true)
    setSavedSsn(ssn)
    saveFn(ssn)
      .then((res) => {
        if (res?.isError) {
          console.error('Failed to save SSN:', res.message)
        }
      })
      .catch((err) => {
        console.error('Failed to save SSN', err)
      })
      .finally(() => {
        setIsSavingSsn(false)
        setShowSsnInput(false)
      })
  }

  return {
    showSsnInput,
    setShowSsnInput,
    savedSsn,
    isSavingSsn,
    ssnFormProps,
    handleSaveSsn
  }
}
